export const providerCheckHandler = ({ key, provider, def = true, params = {} }, getProviderCheck) => {
  const feature = getProviderCheck({ ...params, provider })[key];

  // has provider exist, execute default() when def = true
  if (feature?.hasOwnProperty(provider)) {
    return def ? feature[provider]?.() && feature.default?.() : feature[provider]?.();
  }

  // no provider exist, execute default()
  return feature?.default ? feature?.default?.() : getProviderCheck({}).default?.();
};
